import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

// Register German locale data for date/number/currency pipes
registerLocaleData(localeDe);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
